const HEAD_BYTES = 65536

const IMSIKB_ROOT = 'imsikb0101:featurecollectionimsikb0101'

const LAB_DATAFLOW = 'urn:imsikb0101:datastroomtype:id:1'

const SUPPORTED_IMSIKB_VERSIONS = ['13.5', '14.8', '14.9']

const SIKB9_ANALYSIS_ROOT = 'labresultaat'

const SUPPORTED_SIKB_VERSIONS = ['9', ...SUPPORTED_IMSIKB_VERSIONS]

const LEGACY_SIKB_ROOTS = ['bodeminformatie']

const FIELD_DATA_ROOT = 'velddata'

const FORMAT_BY_ROOT = {
  opdrachtovam: 'import.formats.mistral.v2',
  [SIKB9_ANALYSIS_ROOT]: 'import.formats.sikbAnalysis.v9',
  [FIELD_DATA_ROOT]: 'import.formats.terraIndex.fieldXml'
}

function normaliseVersion(version) {
  if (!version) return null
  const parts = String(version).trim().split('.')
  return parts.length < 2 ? parts[0] : parts[0] + '.' + parts[1]
}

function stripByteOrderMark(text) {
  return text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
}

function readRootElement(xmlHead) {
  const withoutNoise = stripByteOrderMark(String(xmlHead))
    .replace(/<\?[\s\S]*?\?>/g, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<!DOCTYPE[^>]*>/gi, '')

  const match = withoutNoise.match(/<\s*([A-Za-z_][\w:.-]*)/)
  return match ? match[1].toLowerCase() : null
}

function readTagValue(xmlHead, localName) {
  const match = String(xmlHead).match(new RegExp('<[\\w.-]*:?' + localName + '>([^<]*)<', 'i'))
  return match ? match[1].trim() : null
}

function detectImsikbFormat(xmlHead) {
  const version = normaliseVersion(readTagValue(xmlHead, 'version'))
  if (!version || !SUPPORTED_IMSIKB_VERSIONS.includes(version)) return null

  const suffix = version.replace('.', '_')
  const isLab = (readTagValue(xmlHead, 'dataflow') || '').toLowerCase() === LAB_DATAFLOW
  return isLab ? `import.formats.sikbAnalysis.v${suffix}` : `import.formats.sikbProject.v${suffix}`
}

function detectFormatKeyFromXml(xmlHead) {
  if (!xmlHead) return null

  const root = readRootElement(xmlHead)
  if (!root) return null

  if (root === IMSIKB_ROOT) return detectImsikbFormat(xmlHead)

  return FORMAT_BY_ROOT[root] || null
}

function getSikbRejection(xmlHead) {
  const root = readRootElement(xmlHead)
  if (!root) return null

  if (LEGACY_SIKB_ROOTS.includes(root)) return { version: null }

  if (root !== IMSIKB_ROOT) return null

  const version = normaliseVersion(readTagValue(xmlHead, 'version'))
  if (version && SUPPORTED_IMSIKB_VERSIONS.includes(version)) return null

  return { version: version || null }
}

function isFieldJson(jsonHead) {
  if (!jsonHead) return false

  const head = stripByteOrderMark(String(jsonHead)).trimStart()
  if (!head.startsWith('{')) return false

  return /"VeldData"\s*:/.test(head)
}

function pickFieldXmlEntry(entries) {
  if (!entries || !entries.length) return null

  const fieldEntry = entries.find(entry => isFieldXml(entry.content))
  return fieldEntry || entries[0]
}

function isFieldXml(xmlHead) {
  return readRootElement(xmlHead) === FIELD_DATA_ROOT
}

export default {
  HEAD_BYTES,
  SUPPORTED_SIKB_VERSIONS,
  SUPPORTED_IMSIKB_VERSIONS,
  detectFormatKeyFromXml,
  getSikbRejection,
  isFieldJson,
  isFieldXml,
  pickFieldXmlEntry,
  readRootElement
}
